export const featureDataWindowsCleaning = {
    mainTitle: 'Why Choose HRD for Window Cleaning?',
    items: [
        {
            number: '01',
            heading: 'Experienced High-Rise Specialists – Trained in rope access, swing stages, and boom lifts for safe and effective cleaning.'
        },
        {
            number: '02',
            heading: 'Eco-Friendly Cleaning Solutions – Streak- free, biodegradable products that are safe for people and the environment.'
        },
        {
            number: '03',
            heading: 'Minimal Disruption – Flexible scheduling to avoid interfering with business operations.'
        },
        {
            number: '04',
            heading: 'Fully Insured & Safety Compliant – Adhering to WorkSafeBC and industry safety standards.'
        },
        {
            number: '05',
            heading: 'Exceptional Results – Ensuring sparkling clean, streak-free windows every time.'
        }
    ],
    title: "Enhance Your Building’s Appearance Today!",
    subtitle:
        'From office towers and residential high-rises to retail storefronts and industrial facilities, our expert window cleaning services help you maintain a bright, inviting, and professional exterior.',
    ctaText:
        'CONTACT US TODAY TO DISCUSS HOW WE CAN PROTECT AND ENHANCE YOUR PROPERTY!',
    backgroundImage: '/assets/imgs/services/11WindowsCleaning/featuregridSection/fondo.png'
};
